
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor03 as ObiCapacitor03Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-03.js';
 
 
 

 
 export const ObiCapacitor03 = createComponent({
   react: React,
   tagName: 'obi-capacitor-03',
   elementClass: ObiCapacitor03Element,
   events: {
     
   }
  });
 
 